<div class="mat-elevation-z4">
  <mat-toolbar class="table-header">
    <mat-toolbar-row>
      <button type="button" class="btn btn-primary btn-sm mr-1"
        [disabled]="!selectedModel || !selectedModel.ativo || selectedModel.status.codigo != 1 || modelsSelected().length > 1"
        *ngIf="permissoes.executar" (click)="elaborar(selectedModel.id)">
        <i class="far fas fa-pen"></i> Executar
      </button>

      <button type="button" class="btn btn-info btn-sm mr-1" [disabled]="!selectedModel || modelsSelected().length > 1"
        (click)="visualizar(selectedModel?.id)" *ngIf="permissoes.visualizar">
        <i class="far fas fa-eye"></i>
        Visualizar
      </button>

      <button type="button" class="btn btn-info btn-sm mr-1" [disabled]="!selectedModel"
        (click)="imprimir(selectedModel.id)" [hidden]="!permissoes.imprimir || modelsSelected().length > 1">
        <i class="far fas fa-print"></i>
        Imprimir
      </button>

      <button type="button" class="btn btn-info btn-sm mr-1"
              (click)="imprimirRelatorioConsolidado()"
              [hidden]="botaoImpressaoColetivaHidden()">
        <i class="far fas fa-print"></i>
        Imprimir Consolidado
      </button>

      <!-- <button type="button" class="btn btn-info btn-sm mr-1" (click)="teste(65)">
        <i class="far fas fa-print"></i>
        Teste
      </button> -->

      <!--Botões de ações -->
      <span class="fill-remaining-space"></span>

      <div class="input-group input-group-sm" style="width: 100%; display: flex; justify-content: flex-end;">
        <input type="text" name="table_search" class="form-control float-right" style="max-width:30%;"
          (keyup.enter)="filtrarPorNumero()" placeholder="Pesquisar por Número Osa ou Objeto"
          [(ngModel)]="numeroOsaObjeto" />

        <div class="input-group-append">
          <button type="button" class="btn btn-info" (click)="filtrarPorNumero()">
            <i class="fas fa-search"></i>
          </button>
        </div>
        <div class="input-group-append">
          <button class="btn btn-default" type="button" data-toggle="collapse" data-target="#collapseExample"
            aria-expanded="false" aria-controls="collapseExample">
            <i class="fas fa-filter"></i> Filtro Avançado
          </button>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
  <div>
    <ng-content></ng-content>
  </div>

  <table mat-table [dataSource]="dataSource" #tabela1="matSort" matSort matSortDisableClear
    (matSortChange)="sortData($event)" matSortActive="numeroOsa" matSortDirection="asc" *ngIf="!semDados"
    class="w-100 mat-elevation-z8">

    <!-- select Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <!-- <mat-checkbox (click)="$event.stopPropagation()" color="primary" (change)="selectedModel = ($event.checked ? element : null)"
          [checked]="selectedModel?.id === element.id">
        </mat-checkbox> -->
         <mat-checkbox (click)="$event.stopPropagation()" color="primary" (change)="selecionar(element);"
                      [checked]="element?.selecionado">
        </mat-checkbox>
      </td>
    </ng-container>
    <!-- numero Osa -->
    <ng-container matColumnDef="numeroOsa">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Número Osa
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.osa?.numeroOrigem }}
      </td>
    </ng-container>
    <!-- numero Opa -->
    <ng-container matColumnDef="numeroOpa">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Número Opa
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.osa?.planejamento && element?.osa?.planejamento?.opa?.numero }}
      </td>
    </ng-container>
    <!-- ug Auditada -->
    <ng-container matColumnDef="ug">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        UG Auditada
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.osa.unidadeGestora?.sigla }}
      </td>
    </ng-container>
    <!-- status ug Auditada -->
    <ng-container matColumnDef="statusUg">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status Ug</th>
      <td mat-cell *matCellDef="let element">
        {{ element.osa?.statusUg }}
      </td>
    </ng-container>
    <!-- origem -->
    <ng-container matColumnDef="origemAuditoria">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Origem Auditoria
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.osa.planejamento && element?.osa.planejamento?.opa?.origem?.descricao }}
      </td>
    </ng-container>
    <!-- coordenacao -->
    <ng-container matColumnDef="coordenacao">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Coordenação
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.osa.planejamento && element?.osa.planejamento?.opa?.auditorCoordenacao?.coordenacao?.sigla }}
      </td>
    </ng-container>
    <!-- dataInicio execucao -->
    <ng-container matColumnDef="dataInicio">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Data Início de Execução
      </th>
      <td mat-cell *matCellDef="let element">
        <p *ngIf="!element?.osa?.dataInicioRealizacao">
          {{ element?.osa?.planejamento && element?.osa.dataElaboracao | date: "dd/MM/yyyy" }}
        </p>
        <p *ngIf="element?.osa?.dataInicioRealizacao">
          {{ element?.osa?.dataInicioRealizacao | date: "dd/MM/yyyy" }}
        </p>
      </td>
    </ng-container>
    <!-- dataFim execução -->
    <ng-container matColumnDef="dataFim">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Data Fim de Execução
      </th>
      <td mat-cell *matCellDef="let element">
        <p *ngIf="!element?.osa?.dataFimRealizacao">
          {{ element?.osa?.planejamento && element?.osa?.planejamento?.opa?.dataFimPrevista | date: "dd/MM/yyyy" }}
        </p>
        <p *ngIf="element?.osa?.dataFimRealizacao">
          {{ element?.osa?.dataFimRealizacao | date: "dd/MM/yyyy" }}
        </p>
      </td>
    </ng-container>
    <!-- tipo de auditoria -->
    <ng-container matColumnDef="tipoAuditoria">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Tipo de Auditoria
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.osa.planejamento && element?.osa.planejamento?.opa?.tipoAuditoria?.nome }}
      </td>
    </ng-container>
    <!-- status -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Status
      </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="element?.status?.nome === 'EmElaboracao'" class="badge bg-success text-xs">Em Elaboração</span>
        <span *ngIf="element?.status?.nome === 'EmAprovacao'" class="badge bg-warning text-xs">Em Aprovação</span>
        <span *ngIf="element?.status?.nome === 'Homologada'" class="badge bg-primary text-xs">Homologada</span>
        <span *ngIf="element?.status?.nome === 'Cancelada'" class="badge bg-danger text-xs">Cancelada</span>
      </td>
    </ng-container>
    <!-- situacao -->
    <ng-container matColumnDef="situacao">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Situação</th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="element?.ativo === true" class="badge bg-success text-xs">Ativo</span>
        <span *ngIf="element?.ativo === false" class="badge bg-gray-dark text-xs">Inativo</span>
        <i *ngIf="!element.ativo" class="fas fa-info-circle ms-1" matTooltip="{{ element.justificativa }}"
          matTooltipPosition="above" style="cursor: pointer;"></i>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumn"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumn" (click)="selecionar(row)" class="clickable"
      [ngClass]="{'bg-light': selectedModel?.id === row.id && selectedModel?.grupo === row.grupo}"></tr>
  </table>

  <h5 [hidden]="!semDados" class="table-no-data">Nenhum registro encontrado</h5>

  <mat-paginator class="mt-4" [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons [length]="totalItens"
    (page)="selectedModel = null; pageEvent = pageChanged($event)">
  </mat-paginator>
</div>